import { IAddNewsRating } from "../../repository/IAddNewsRating";

export const addRating = (payload: IAddNewsRating) => ({
  type: "@saga/ADD_RATING",
  payload,
});
